import type { QueryClient } from "@tanstack/react-query";
import { clearMessageDrafts } from "../messaging/drafts";

export function clearClinicalSession(
  queryClient: QueryClient,
  clearEncounterSelection: () => void,
): void {
  clearEncounterSelection();
  clearMessageDrafts();
  queryClient.clear();
}
